import React, { Fragment } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import PropTypes from 'prop-types'
import Swal from 'sweetalert2'

import Dashboard from '@wrappers/Dashboard'
import { Title } from '@lib'
import TemplateFieldValueForm from '@shared/TemplateFieldValueForm'

const Content = ({ user }) => {
  const { id } = useParams()
  const navigate = useNavigate()

  const handleSave = () => {
    Swal.fire({
      text: 'Field allowed value updated!',
      icon: 'success',
      showConfirmButton: false,
      timer: 3000
    })

    navigate('/datalogic/template-settings#template-field-values')
  }

  return (
    <Fragment>

      <Title text='Edit Template Field Allowed Value' user={user}/>

      <TemplateFieldValueForm
        id={id}
        onSave={handleSave}
      />
    </Fragment>
  )
}

Content.propTypes = {
  user: PropTypes.object
}

const EditTemplateFieldValue = () => {
  return (
    <Dashboard>
      <Content />
    </Dashboard>
  )
}

export default EditTemplateFieldValue
